export default __webpack_public_path__ + "static/media/4.416d9da7.png";